import { useMutation } from '@tanstack/react-query';
import { addKYC } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useAddKYC({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const Request = useMutation({
    mutationFn: addKYC,
    mutationKey: ['addKYC'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
    },
  });
  return { ...Request };
}
